// The client side of /api/scoring (BUILD-BRIEF-R2 §10) — owned by the `scoring` agent.
//
// Note what is NOT here: any way to write a weight. The rule document changes through a
// `rule_change` proposal an operator holds in Review, so `getRules` is read-only and there is
// no `setRules` to reach for (§10, utils/appliers/rule_change.ts). If a page ever needs to
// change a rule, it files a proposal.
import { qs, request } from './client.js';
import type { Action, ListResponse, Score, ScoringRules } from '../../shared/types.js';

export function listActions(params: { limit?: number; status?: string; person_id?: number } = {}): Promise<ListResponse<Action>> {
  return request(`/scoring/actions${qs(params)}`);
}

/** The Today zone's five, already ordered by score. */
export function topActions(limit = 5): Promise<ListResponse<Action>> {
  return request(`/scoring/actions/top${qs({ limit })}`);
}

/** Null when nothing has scored them yet — which is not a score of zero. */
export function getScore(personId: number): Promise<Score | null> {
  return request(`/scoring/scores/${personId}`);
}

/** The whole ladder, for PeoplePage's "By score" chip and its score slot. */
export function listScores(limit?: number): Promise<ListResponse<Score>> {
  return request(`/scoring/scores${qs({ limit })}`);
}

export function recompute(personId?: number): Promise<{ scored: number; actions: number; expired: number }> {
  return request('/scoring/recompute', { method: 'POST', body: JSON.stringify({ person_id: personId ?? null }) });
}

export function completeAction(id: number, doneRef?: string): Promise<Action> {
  return request(`/scoring/actions/${id}/done`, { method: 'POST', body: JSON.stringify({ done_ref: doneRef ?? null }) });
}

export function dismissAction(id: number): Promise<Action> {
  return request(`/scoring/actions/${id}/dismiss`, { method: 'POST' });
}

/** Read-only here on purpose: weights change through a `rule_change` proposal, never a PATCH. */
export function getRules(): Promise<ScoringRules> {
  return request('/scoring/rules');
}
